import React, { PureComponent, PropTypes } from 'react'
import Button from '../Button'
import styles from './styles'

export default class NextButton extends PureComponent {
  static propTypes = {
    onClick: PropTypes.func,
    children: PropTypes.any,
    disabled: PropTypes.bool,
  }

  render() {
    const { children, onClick, disabled } = this.props
    return (
      <Button onClick={onClick} disabled={disabled}>
        {children}
        <svg viewBox='0 0 24 24' className={styles.svg}>
          <polygon points='20,21 16.943,24 5,12 16.943,0 20,3 11,12' />
        </svg>
      </Button>
    )
  }
}



/** WEBPACK FOOTER **
 ** ../app/Components/Survey/BottomBar/NextButton/NextButton.js
 **/